import React from 'react';
import AnimatedSection from '../common/AnimatedSection';

const CompanyOverview = () => {
    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <AnimatedSection animation="fadeIn">
                    <h2 style={styles.sectionTitle}>Our <span style={styles.highlight}>Story</span></h2>
                    <div style={styles.sectionDivider}></div>
                    
                    <div style={styles.twoColumnLayout}>
                        <div style={styles.column}>
                            <p style={styles.text}>
                                <strong>Dee Cee Elevators Pvt Ltd</strong> is a pioneering name in the elevator industry, 
                                known for quality, innovation, and customer satisfaction. With over 13 years of experience 
                                and headquartered in Jaipur, India, we have established a strong presence across Western U.P.
                            </p>
                            <p style={styles.text}>
                                Our specialty lies in creating bespoke designer lifts that seamlessly integrate with any 
                                building's architectural aesthetics. From hospitals and factories to residential houses, 
                                hotels, and showrooms, Dee Cee Elevators provides tailored solutions for various sites.
                            </p>
                            <p style={styles.text}>
                                
                            </p>
                        </div>
                        <div style={styles.column}>
                            <div style={styles.missionVisionBox}>
                                <div style={styles.missionBox}>
                                    <h3 style={styles.boxTitle}><i className="fas fa-bullseye" style={styles.boxIcon}></i> Our Mission</h3>
                                    <p style={styles.boxText}>
                                        To enhance urban mobility with safe, reliable, and efficient elevator systems that 
                                        transform how people move through buildings.
                                    </p>
                                </div>
                                <div style={styles.visionBox}>
                                    <h3 style={styles.boxTitle}><i className="fas fa-eye" style={styles.boxIcon}></i> Our Vision</h3>
                                    <p style={styles.boxText}>
                                        To set the industry benchmark with cutting-edge technology and exceptional service,
                                        becoming the premier elevator company in India.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </AnimatedSection>
            </div>
        </section>
    );
};

const styles = {
    section: {
        padding: '90px 0',
        backgroundColor: '#ffffff',
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
    },
    sectionTitle: {
        fontSize: '2.5rem',
        fontWeight: '800',
        textAlign: 'center',
        marginBottom: '15px',
        color: '#2c3e50',
    },
    highlight: {
        color: '#163ba2',
    },
    sectionDivider: {
        width: '80px',
        height: '4px',
        backgroundColor: '#163ba2',
        margin: '0 auto 50px',
        borderRadius: '2px',
    },
    text: {
        fontSize: '1.1rem',
        color: '#4b5563',
        lineHeight: '1.8',
        marginBottom: '20px',
    },
    twoColumnLayout: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        gap: '40px',
    },
    column: {
        flex: '1 1 450px',
    },
    missionVisionBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        height: '100%',
    },
    missionBox: {
        backgroundColor: '#163ba2',
        padding: '30px',
        borderRadius: '10px',
        color: 'white',
        flex: 1,
    },
    visionBox: {
        backgroundColor: '#f8fafc',
        padding: '30px',
        borderRadius: '10px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
        flex: 1,
    },
    boxTitle: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1.5rem',
        fontWeight: '700',
        marginBottom: '15px',
    },
    boxIcon: {
        marginRight: '12px',
        fontSize: '1.2rem',
    },
    boxText: {
        fontSize: '1.1rem',
        lineHeight: '1.7',
    },
    '@media (max-width: 992px)': {
        sectionTitle: {
            fontSize: '2.2rem',
        },
    },
    '@media (max-width: 820px)': {
        section: {
            padding: '70px 0',
        },
        sectionTitle: {
            fontSize: '2rem',
        },
    },
    '@media (max-width: 576px)': {
        section: {
            padding: '50px 0',
        },
        sectionTitle: {
            fontSize: '1.8rem',
        },
    }
};

export default CompanyOverview;